import React, {useEffect, useState} from 'react'
import {ModeleMesActions, modeleMesActionsInitValues} from '../../../components/Models'
import {useNavigate, useParams} from 'react-router-dom'
import {editAction, getOneAction, readMesActions} from '../../../components/requests'
import {MesActionsForm} from './components/MesActionsForm'
import {LoadingData} from '../../../components/LoadingData'
import {shouldDisplayFonctionnalite} from '../../../components/helpers'
import {useAuth} from '../../modules/auth'
import {useLocation} from 'react-router'

interface LocationState {
  readOnly?: boolean
  isRealisation?: boolean
  viaListAction?: boolean
  view?: 'List' | 'Kanban' | 'Table' | null | undefined
  filters?: any
}

const MesActionsEditPage = (props) => {
  const navigate = useNavigate()
  let {actionId} = useParams()
  const [data, setData] = useState<any>()
  const [loading, setLoading] = useState(true)
  const {currentUser} = useAuth()
  const location = useLocation()
  const ls = location.state as LocationState | null

  useEffect(() => {
    if (props?.handleFilterArian) {
      props.handleFilterArian(ls?.view, ls?.filters)
    }
  }, [])

  useEffect(() => {
    getActionData()
  }, [actionId])

  const getActionData = () => {
    getOneAction(actionId)
      .then((actionRequest) => {
        if (actionRequest?.status === 200) {
          if (actionRequest?.data?.id !== undefined && actionRequest?.data?.id !== null) {
            const updatedData = Object.assign({...data}, actionRequest?.data)
            if (
              !shouldDisplayFonctionnalite(currentUser, 'MODIFIER ACTION')
              // || updatedData?.statut?.id !== 1
            ) {
              navigate(`/mes-actions/liste`, {state: {view : ls?.view, filters: ls?.filters}})
            }
            if (!actionRequest?.data?.lu) readMesActions(actionRequest.data)
            setData({...updatedData})

            // Pour lire l'action non lu lors de l'ouverture via la liste des actions
            if (ls?.viaListAction && !updatedData.lu) readMesActions(updatedData.id)
          }
          setLoading(false)
        } else {
          navigate(`/mes-actions/liste`, {state: {view : ls?.view, filters: ls?.filters}})
        }
      })
      .catch((e) => {
        setLoading(false)
        navigate(`/mes-actions/liste`, {state: {view : ls?.view, filters: ls?.filters}})
      })
  }

  const submitForm = async (fieldsToUpdate: Partial<ModeleMesActions>, callback): Promise<void> => {
    const updatedData = Object.assign({...modeleMesActionsInitValues}, fieldsToUpdate)

    var requestOk = false
    try {
      const actionRequest = await editAction(actionId, updatedData)
      if (actionRequest?.status === 200) {
        requestOk = true
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      callback()
      if (requestOk) {
        setData({...updatedData})
        navigate(`/mes-actions/liste`, {state: {view : ls?.view, filters: ls?.filters}})
      }
    }
  }

  return (
    <>
      {loading ? (
        <LoadingData />
      ) : (
        <div className='card mb-5 mb-xl-10'>
          <div className='card-header border-0'>
            <div className='card-title m-0'>
              <h3 className='fw-bolder m-0'>Modifier une action</h3>
            </div>
          </div>
          <div>
            <MesActionsForm data={data} submitForm={submitForm} readOnly={ls?.readOnly} isRealisation={ls?.isRealisation} statutButton={!ls?.isRealisation} view={ls?.view} filters={ls?.filters}/>
          </div>
        </div>
      )}
    </>
  )
}

export default MesActionsEditPage
